<router-outlet>

</router-outlet>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/confirmation/confirmation.component.html